import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import ErrorBoundary from './components/ErrorBoundary'
import './index.css'

console.log('[INIT] Starting JobClientFinder application...')
console.log('[INIT] Environment:', {
  supabaseUrl: import.meta.env.VITE_SUPABASE_URL,
  hasAnonKey: !!import.meta.env.VITE_SUPABASE_ANON_KEY,
  mode: import.meta.env.MODE,
  isDev: import.meta.env.DEV,
  isProd: import.meta.env.PROD
})

if (!import.meta.env.VITE_SUPABASE_URL) {
  console.error('[INIT ERROR] Missing VITE_SUPABASE_URL environment variable')
}

if (!import.meta.env.VITE_SUPABASE_ANON_KEY) {
  console.error('[INIT ERROR] Missing VITE_SUPABASE_ANON_KEY environment variable')
}

try {
  const rootElement = document.getElementById('root')
  if (!rootElement) {
    throw new Error('Root element not found')
  }

  console.log('[INIT] Root element found, mounting React app...')

  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </React.StrictMode>
  )

  console.log('[INIT] React app mounted successfully')
} catch (error) {
  console.error('[INIT ERROR]', error)
  document.body.innerHTML = `
    <div style="min-height: 100vh; display: flex; align-items: center; justify-content: center; padding: 24px; background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;">
      <div style="max-width: 600px; width: 100%; background: rgba(255, 255, 255, 0.15); backdrop-filter: blur(20px); border-radius: 24px; padding: 40px; border: 1px solid rgba(255, 255, 255, 0.3); box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);">
        <h1 style="font-size: 32px; font-weight: 800; color: white; margin-bottom: 16px; text-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);">Application Error</h1>
        <p style="font-size: 16px; color: rgba(255, 255, 255, 0.9); margin-bottom: 24px; line-height: 1.6;">Failed to initialize the application. Please check the console for more details.</p>
        <details style="background: rgba(0, 0, 0, 0.2); padding: 16px; border-radius: 12px; margin-bottom: 24px; font-size: 14px; color: rgba(255, 255, 255, 0.8);">
          <summary style="cursor: pointer; font-weight: 600; margin-bottom: 8px;">Error Details</summary>
          <pre style="font-size: 12px; overflow: auto; white-space: pre-wrap; word-break: break-word;">${error.message}\n${error.stack || ''}</pre>
        </details>
        <button onclick="window.location.reload()" style="width: 100%; padding: 14px 24px; font-size: 16px; font-weight: 700; color: white; background: rgba(255, 255, 255, 0.25); border: 2px solid rgba(255, 255, 255, 0.4); border-radius: 12px; cursor: pointer; box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);">Reload Page</button>
      </div>
    </div>
  `
}
